// ------- Form Messages --------
export const CANNOT_BE_BLANK = 'Can\'t be blank.';
export const NETWORK_ERROR = 'Something went wrong. Please try again later.';

// Profile:
export const PROFILE_FORM = {
  // Error messages:
  ERR_INVALID_EMAIL: 'Please enter a valid email.',
  ERR_SAME_EMAIL: 'Please enter a new email.',
  ERR_EXISTING_EMAIL: 'This email has already been taken. Please enter a new email.',
  ERR_SHORT_PASSWORD: 'Password is too short (minimum 6 characters)',
  ERR_PASSWORDS_MATCH: 'Passwords do not match.',
  ERR_INVALID_PHONE: 'Number is invalid.',
  // Warning messages:
  WAR_CANNOT_BE_UNDONE: 'Warning: This action cannot be undone.',
  // Success messages:
  OK_CHANGE_PASSWORD: 'Your password has been successfully changed.',
  OK_CREATE_PASSWORD: 'Your new password has been successfully created.',
};

// Listing Page:
export const LISTING_PAGE = {
  ERR_LISTING_NOT_FOUND: 'Listing Not Found',
  ERR_LISTING_NOT_FOUND_DESCRIPTION: 'The address you requested does not exist or is no longer available.',
};
